import { createStore as _createStore, applyMiddleware, compose } from 'redux';

import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import promiseMiddleware from 'redux-promise-middleware';
import loggerMiddleware from './middleware/logger';

declare const module: any;
declare const window: any;

/**
 * Снимок из localStorage кладём поверх дефолтов каждого редьюсера, а не вместо
 * них: combineReducers подменяет слайс целиком, поэтому частичный снимок (мы
 * храним только выбор пользователя) обнулил бы всё остальное в этом слайсе -
 * в первую очередь userContext и rolesData, которые header берёт из ключа
 * localStorage.userContext.
 *
 * Дефолты получаем прогоном самого редьюсера с state = undefined, чтобы не
 * тянуть сюда initialState каждого модуля.
 */
function mergeWithDefaults(reducer: any, data: any) {
    const defaults = reducer(undefined, { type: '@@ecash/INIT_DEFAULTS' });

    if (!data) {
        return defaults;
    }

    return Object.keys(defaults).reduce((acc: any, slice: string) => {
        const persisted = data[slice];
        const initial = defaults[slice];
        const mergeable = persisted && typeof persisted === 'object' && initial && typeof initial === 'object';

        acc[slice] = mergeable ? { ...initial, ...persisted } : initial;
        return acc;
    }, {});
}

export default function createStore(history: any, client: any, data: any) {
    const reduxRouterMiddleware = routerMiddleware(history);

    const middleware = [reduxRouterMiddleware, promiseMiddleware, thunk, loggerMiddleware];

    let finalCreateStore;

    if (process.env.REACT_APP_DEVELOPMENT && process.env.REACT_APP_CLIENT) {
        const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        finalCreateStore = composeEnhancers(applyMiddleware(...middleware))(_createStore);
    } else {
        finalCreateStore = applyMiddleware(...middleware)(_createStore);
    }

    const reducer = require('./modules/reducer').default;

    const store = finalCreateStore(reducer, mergeWithDefaults(reducer, data));

    if (process.env.REACT_APP_DEVELOPMENT && module.hot) {
        module.hot.accept('./modules/reducer', () => {
            store.replaceReducer(require('./modules/reducer').default);
        });
    }

    return store;
}

